<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">

    <!-- Route craft section start -->
    <div class="route-craft-main-container" *ngIf="dmcPackageDetails?.routeCraftDmc">
      <div class="ion-no-padding mb-1">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Route Craft</ion-title>
      </div>
      <div>
        <div class="ion-padding-horizontal">
          <div class="day-to-day-main-container" *ngIf="dmcPackageDetails?.routeCraftDmc?.selectedRouteType === ROUTE_CRAFT_TYPES.DAY_PLANNER">
            <div class="route-craft-item"
              *ngFor="let day of dmcPackageDetails.routeCraftDmc?.dayToDayPlan; index as dayIndex">
              <div class="d-flex justify-content-between">
                <div class="content-container">
                  <div>
                    <p class="date-title">Day {{dayIndex+1}} | {{getDayFromDate(getRouteDate(dayIndex))}} |
                      {{getRouteDate(dayIndex) | date: 'dd MMM YYYY'}}</p>
                    <p class="day-title">{{day.day}}</p>
                  </div>
                </div>
                <div class="meal-plan-container">
                  <p class="meals-label">Meal Plan Included</p>
                  <div class="d-flex justify-content-center">
                    <div class="text-center meal-item api-breakfast me-2">
                      <div>
                        <p class="label" *ngIf="day.mealPlan?.length">{{day.mealPlan.join(' | ')}}</p>
                        <p class="label" *ngIf="!day.mealPlan?.length">No Meal Plan Added</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2">
                <div class="activities" [innerHTML]="day.activities"></div>
              </div>
            </div>
          </div>

          <!-- Free text route craft -->
          <div class="day-to-day-main-container" *ngIf="dmcPackageDetails?.routeCraftDmc?.selectedRouteType === ROUTE_CRAFT_TYPES.FREE_TEXT">
            <div class="route-craft-item">
              <div class="activities" [innerHTML]="dmcPackageDetails?.routeCraftDmc?.freeText?.text"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Route craft section end -->

    <!-- Pricing Form start -->
    <div class="ion-no-padding mb-1">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">DMC Hotel Pricing</ion-title>
    </div>
    <form [formGroup]="hotelPricingForm" *ngIf="hotelPricingForm && dmcPackageDetails">
      <div class="form-container ion-padding-horizontal">
        <div>
          <div class="">
            <ng-container formArrayName="packages">
              <div class="mt-1 package-main-container"
                *ngFor="let package of getPackagesFormArray().controls; index as packageIndex"
                [formGroupName]="packageIndex">
                <div class="package-title-container p-1">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <p class="package-index">Package {{packageIndex+1}}</p>
                    </div>
                    <div class="d-flex align-items-center">
                      <label for="" class="category-label fw-bold me-3">Hotel Category:
                        {{package.get('hotelCategory')?.value}}</label>
                    </div>
                  </div>
                </div>


                <!-- Package table container -->
                <div class="pricing-table-container">
                  <table class="pricing-table locations-table">
                    <thead>
                      <tr>
                        <th rowspan="2" style="min-width: 180px;">Location/Hotel</th>
                        <th rowspan="2" style="width: 50px; border-right: 0;">Nights</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container formArrayName="locations">
                        <tr *ngFor="let location of getLocationsFormArray(packageIndex).controls;index as locationIndex"
                          [formGroupName]="locationIndex">
                          <td>
                            <div class="location-item">
                              <div class="location">
                                <p class="name">{{location.get('locationName')?.value}}</p>
                              </div>
                              <div class="hotel input-container">
                                <div>
                                  <p class="fs-6 mb-0">{{location.get('hotelName')?.value}}</p>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td class="text-center">{{location.get('nights')?.value}}</td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>

                  <table class="pricing-table pax-table">
                    <thead>
                      <tr>
                        <th rowspan="2" style="width: 90px;">Pax Count</th>
                        <th colspan="3">Occupancy <span style="font-size: 70%;">(Select atleast a value)</span></th>
                        <th rowspan="2" style="width: 90px;">Child with Bed</th>
                        <th rowspan="2" style="width: 90px;">Extra Child without Bed</th>
                      </tr>
                      <tr>
                        <th style="width: 90px;">SGL</th>
                        <th style="width: 90px;">DBL</th>
                        <th style="width: 90px;">TPL</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container formArrayName="occupancyPricings">
                        <tr
                          *ngFor="let occupancy of getOccupancyPricingsFormArray(packageIndex).controls;index as occupancyIndex"
                          [formGroupName]="occupancyIndex">
                          <td>
                            <div class="pax-container" formGroupName="paxRange">
                              <div>
                                <p class="data">{{occupancy.get('paxRange.minRange')?.value}}</p>
                              </div>
                              <label for="" class="mx-1">-</label>
                              <div>
                                <p class="data">{{occupancy.get('paxRange.maxRange')?.value}}</p>
                              </div>
                            </div>
                          </td>
                          <ng-container formGroupName="occupancy">
                            <td>
                              <div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <input type="radio" class="me-1" [name]="'occupancy'+occupancyIndex+ ' '+ packageIndex" value="sgl" [checked]="occupancy.get('selectedOccupancy')?.value === OCCUPENCY_TYPES.SGL" (change)="occupancyChanged($event, packageIndex, occupancyIndex)" [disabled]="!occupancy.get('occupancy.sgl')?.value">
                                  <p class="data">{{occupancy.get('occupancy.sgl')?.value || "--"}}</p>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <input type="radio" class="me-1" [name]="'occupancy'+occupancyIndex+ ' '+ packageIndex" value="dbl" [checked]="occupancy.get('selectedOccupancy')?.value === OCCUPENCY_TYPES.DBL" (change)="occupancyChanged($event, packageIndex, occupancyIndex)" [disabled]="!occupancy.get('occupancy.dbl')?.value">
                                  <p class="data">{{occupancy.get('occupancy.dbl')?.value || "--"}}</p>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div>
                                <div class="d-flex align-items-center justify-content-center">
                                  <input type="radio" class="me-1" [name]="'occupancy'+occupancyIndex+ ' '+ packageIndex" value="tpl" [checked]="occupancy.get('selectedOccupancy')?.value === OCCUPENCY_TYPES.TPL" (change)="occupancyChanged($event, packageIndex, occupancyIndex)" [disabled]="!occupancy.get('occupancy.tpl')?.value">
                                  <p class="data">{{occupancy.get('occupancy.tpl')?.value || "--"}}</p>
                                </div>
                              </div>
                            </td>
                          </ng-container>
                          <td>
                            <div>
                              <p class="data">{{occupancy.get('childWithBed')?.value || "--"}}</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p class="data">{{occupancy.get('extraChildWithoutBed')?.value || "--"}}</p>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </form>
    <!-- Pricing Form end -->

    <!-- Transfers section start -->
    <div *ngIf="dmcPackageDetails?.transfersPackage && dmcPackageDetails?.transfersPackage?.enableTransfer">
      <div class="ion-no-padding my-2">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Transfers</ion-title>
      </div>
      <div class="transportation-main-container ion-padding-horizontal">
        <div class="transportations-container">
          <!-- Single transport start -->
          <div class="transportation-item"
            *ngFor="let vehicle of dmcPackageDetails?.transfersPackage?.transfersDetails">
            <div class="details-container">
              <div class="data-grid">
                <p class="label">Pax Count</p>
                <p class="value mb-0">{{vehicle.paxRange.minRange}}-{{vehicle.paxRange.maxRange}}</p>
                <p class="label">Vehicle Type</p>
                <p class="value mb-0">{{vehicle.vehicleType}}</p>
                <p class="label">Note</p>
                <p class="value mb-0 inner-html-notes" [innerHTML]="vehicle.note"></p>
              </div>
            </div>
            <div class="image-container">
              <img [src]="vehicle.imagePath" alt="transport-img" class="transport-img">
            </div>
          </div>
          <!-- Single transport end -->
        </div>
      </div>
    </div>

    <!-- Transfers section end -->

    <!-- Optinal sightseeing start -->
    <div *ngIf="dmcPackageDetails?.optionalSightSeeing && dmcPackageDetails?.optionalSightSeeing?.enableSightseeing">
      <div class="ion-no-padding my-2">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Optional Sightseeing</ion-title>
      </div>
      <div class="package-main-container ion-padding-horizontal border-0">
        <div class="pricing-table">
          <table class="pricing-table w-100">
            <thead>
              <tr>
                <th style="width: 200px;">Location</th>
                <th>Visiting Place</th>
                <th style="width: 100px;">Cost</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let place of dmcPackageDetails?.optionalSightSeeing?.locations">
                <tr>
                  <td [rowSpan]="place.visitingPlaces?.length + 1">{{place.locationName}}</td>
                </tr>
                <tr *ngFor="let visitingPlace of place.visitingPlaces">
                  <td>{{visitingPlace.place}}</td>
                  <td class="data">{{visitingPlace.cost}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Optinal sightseeing end -->
  </div>

  <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>